import {DropdownMultiSelect} from "common";
import {memo} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {ClientReturnsTransferRequestInput} from "./ClientTransferReturnRequestFormAuthModal";
import {SPLIT_DELIMITER, splitAndRemoveEmpty} from "placement/const";
import {ClinicalRecommendationChangeOptionMap, ServiceLocationOptionMap} from "./domain"
import { ModalTextAreaInput } from "../../form-components/ModalTextAreaInput";
import { ModalSelectionInput } from "../../form-components/ModalSelectionInput";

type ClientReturnsTransferClinicalChangesInputProps = {
    sending: boolean,
};
export const ClientReturnsTransferClinicalChangesInput = memo(({
                                                                   sending,
                                                               }: ClientReturnsTransferClinicalChangesInputProps) => {
    const {
        control,
        setValue,
        watch,
        clearErrors,
        formState: {
            errors
        }
    } = useFormContext<ClientReturnsTransferRequestInput>();

    return (
        <div className="w-full text-black-200 pb-2 text-base items-center">
            <div className="flex items-center">
                <div className="w-2/6 text-right">
                    Clinical Recommendation Changes
                </div>
                <div className="w-3/6 ml-4 items-center">
                    <Controller
                        name="clinicalRecommendationChange"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={() => {
                            return (
                                <DropdownMultiSelect
                                    width={'w-full'}
                                    field='clinicalRecommendationChange'
                                    placeholder={'- Recommendation Changes'}
                                    options={Array.from(ClinicalRecommendationChangeOptionMap.keys())}
                                    labelMapperFunc={(val) => ClinicalRecommendationChangeOptionMap.get(val)!}
                                    disabled={sending}
                                    value={watch('clinicalRecommendationChange') ?? ""}
                                    setValue={(value: string) => {
                                        setValue("clinicalRecommendationChange", splitAndRemoveEmpty(value).join(SPLIT_DELIMITER))
                                        clearErrors("clinicalRecommendationChange");
                                    }}
                                    hasError={errors.clinicalRecommendationChange !== undefined}
                                />
                            );
                        }}/>
                </div>
            </div>

            {
                errors.clinicalRecommendationChange &&
                <div className='flex'>
                    <div className={'w-2/6'}/>
                    <div className="w-3/6 ml-4 items-center text-red-700">
                        Please select at least 1 option for the Clinical Recommendation Changes field
                    </div>
                </div>
            }
            <ModalTextAreaInput
                label={'Rationale'}
                disabled={sending}
                field={'rationale'}
                required={true}
                maxLength={5000}
            />
        </div>
    );
});
